import { render, staticRenderFns } from "./CommercialDialCampaign.vue?vue&type=template&id=1fb43c50&scoped=true"
import script from "./CommercialDialCampaign.vue?vue&type=script&lang=js"
export * from "./CommercialDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./CommercialDialCampaign.vue?vue&type=style&index=0&id=1fb43c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb43c50",
  null
  
)

export default component.exports